import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, IDP_APP, MFA_OAUTH_URL } from '../../../../constants';
import { LoginOAuthResponse, OauthAEMConfig } from '../../../../models';
import { UtilService } from '../../../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class LoginRedirectfulService {
  redirectfulHeader: HttpHeadersPayload = {
    'x-xsrf-header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private utils: UtilService,
    private http: HttpClient,
    private appConfig: AppConfigService
  ) {}

  loginRedirectful = (
    authConfig: OauthAEMConfig,
    flowId: string
  ): Observable<LoginOAuthResponse> => {
    const getLoginRedirectfulUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowId
    ).loginOAuthRedirectfulUrl;

    const loginRedirectfulUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: getLoginRedirectfulUrl
      }
    ];

    return new ApiBuilder<undefined, LoginOAuthResponse>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(loginRedirectfulUrl)
      .method(HttpRequestMethods['GET'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .httpHeaders(this.redirectfulHeader)
      .errorHandler(this._errorHandler)
      .library('LOGIN_REDIRECTFUL_SERVICE')
      .withCredentials(true)
      .create();
  };
}
